<p class="pc-contact__title">Ways to reach PALFINGER:</p>

<ul class="pc-contact__list">
  @for (option of $options(); track option) {
    <li>
      @switch (option) {
        @case ('spareParts') {
          <a
            class="pc-contact__option"
            [href]="sparePartsCaseUrl"
            target="_blank"
            rel="noopener"
          >
            <strong>Spare Parts Case</strong>
            <span>
              Existing orders, shipments, invoices, missing spare parts or
              address changes
            </span>
            <em>Create ticket</em>
          </a>
        }
        @case ('paldeskSupport') {
          <button
            type="button"
            class="pc-contact__option"
            (click)="openPaldeskSupport()"
          >
            <strong>Contact PALDESK support</strong>
            <span>Open a support ticket without leaving PALDESK</span>
          </button>
        }
        @case ('paldeskEmail') {
          <a class="pc-contact__option" href="mailto:paldesk@palfinger.com">
            <strong>Email PALDESK support</strong>
            <span>paldesk&#64;palfinger.com</span>
          </a>
        }
        @case ('findDealer') {
          <a
            class="pc-contact__option"
            href="https://www.palfinger.com/worldwide/en/dealer-search.html"
            target="_blank"
            rel="noopener"
          >
            <strong>Find a dealer</strong>
            <span>Your nearest PALFINGER partner</span>
          </a>
        }
        @case ('palfingerAg') {
          <div class="pc-contact__option pc-contact__option--static">
            <strong>PALFINGER AG</strong>
            <span
              >Lamprechtshausener Bundesstra&szlig;e 8, 5101 Bergheim, AT</span
            >
            <span>
              <a href="mailto:info@palfinger.com">info&#64;palfinger.com</a>
              &middot;
              <a href="tel:+4366222810">+43 66 222 810</a>
            </span>
          </div>
        }
        @case ('palfingerMarine') {
          <a
            class="pc-contact__option"
            href="https://www.palfinger.com/europe/en/contact-us/palfinger-marine-contacts.html"
            target="_blank"
            rel="noopener"
          >
            <strong>PALFINGER MARINE</strong>
            <span>Marine and offshore equipment contacts</span>
          </a>
        }
      }
    </li>
  }
</ul>
